<template>
  <div>
    <Head title="Cushions Issuances" />
    <h1 class="mb-8 text-3xl font-bold">Cushions Issuances</h1>

    <div class="bg-white rounded-md shadow mb-5">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-2 -mr-6 pt-8 pr-8 pl-8 pb-8">
          <div class="pb-2 pr-6 w-full lg:w-1/3">
            <multiselect
              id="issuance_team"
              v-model="form.issuance_team"
              placeholder="Search Locations"
              :options="issuanceTeams" 
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.issuance_team"
              :style="form.errors.issuance_team ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
            />
            <div v-if="form.errors.issuance_team" class="form-error">{{ form.errors.issuance_team }}</div>
          </div>
          <div class="pb-2 pr-6 w-full lg:w-1/3">
            <text-input
              v-model="form.quantity"
              :error="form.errors.quantity"
              placeholder="Quantity"
            />
          </div>
          <div class="pb-2 pr-6 w-full lg:w-1/3">
            <text-input
              v-model="form.sku_id"
              :error="form.errors.sku_id"
              placeholder="Scan SKU"
            />
          </div>
        </div>
          <div
            class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
          >
            <loading-button
              :loading="form.processing"
              class="btn-orange px-3 py-2 text-xs"
              type="submit"
            >
              Add Issuance
            </loading-button>
          </div>
      </form>
    </div>
    <hr/>
    <ul class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4" id="tabs-tabFill"
      role="tablist">
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-homeFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active
        " id="tabs-home-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-homeFill" role="tab"
          aria-controls="tabs-homeFill" aria-selected="true">Today's Scans</a>
      </li>
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-profileFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
        " id="tabs-profile-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-profileFill" role="tab"
          aria-controls="tabs-profileFill" aria-selected="false">All Scans</a>
      </li>
    </ul>
    <div class="tab-content" id="tabs-tabContentFill">
      <div class="tab-pane fade show active" id="tabs-homeFill" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Date</th>
              <th class="pb-2 pt-2 px-3">Team</th>
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Description</th>
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
              <th class="pb-2 pt-2 px-3">Issued By</th>            
            </tr>
            <tr v-for="item in issuances.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500">
                  {{ item.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.issuance_team }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.part_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.measure }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.user }}
                </Link>
              </td>
              <td class="w-px border-t">
                <Link class="flex items-center px-3" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </Link>
              </td>
            </tr>
            <tr v-if="issuances.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="8">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="issuances.links" />
      </div>
      <div class="tab-pane fade" id="tabs-profileFill" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="flex items-center justify-between mb-6">
          <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md mr-3"  @reset="reset"/>
          <a
            v-if="manufacturing_issuances.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/cushions/issuances/download?dateValue=${search.dateValue}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Date</th>
              <th class="pb-2 pt-2 px-3">Team</th>
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Description</th>
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
              <th class="pb-2 pt-2 px-3" colspan="2">Issued By</th>              
            </tr>
            <tr v-for="manufacturing_issuance in manufacturing_issuances.data" :key="manufacturing_issuance.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500">
                  {{ manufacturing_issuance.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ manufacturing_issuance.issuance_team }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ manufacturing_issuance.part_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ manufacturing_issuance.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ manufacturing_issuance.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ manufacturing_issuance.measure }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ manufacturing_issuance.user }}
                </Link>
              </td>
              
              <td class="w-px border-t">
                <Link class="flex items-center px-3" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </Link>
              </td>
            </tr>
            <tr v-if="manufacturing_issuances.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="12">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="manufacturing_issuances.links" />
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Layout from '@/Shared/Layout'
import DateRange from '@/Shared/DateRange'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    //Icon,
    Link,
    DateRange,
    TextInput,
    SelectInput,
    LoadingButton,
    Pagination,
    Multiselect,
  },
  layout: Layout,
  props: {
    filters: Object,
    issuances: Object,
    issuanceTeams: Object,
    manufacturing_issuances: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        sku_id: null,
        quantity: null,
        issuance_team: null,
      }),
      search: {
        dateValue: this.filters.dateValue
      },
      selectedLocation: null,
    }
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/cushions-issuances/', pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    store() {
      this.form.post('/cushions-issuances', {
        onSuccess: () => {
          this.form.reset(
            'sku_id',
            'quantity',
          )
        },
      });
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
